import {
  Button,
  Checkbox,
  Drawer,
  Form,
  Input,
  notification,
  Space,
  Spin,
} from 'antd';
import { FisheryProfileSubSection as SubSection } from './FisheryProfileSection';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import '../assets/css/fishery_profile_footer.css';
import MenuDrawer from '../../common/components/menu/MenuDrawer';
import UserLoginForm from '../../common/UserLoginForm';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import axios from 'axios';
import EmailIllustration from '../../../assets/images/Icons/SVG/EmailIllustration';
import { useGetFisheryQuery } from '../fisherySlice';
import { useWeather } from './SBOpenWeather';
import { useFormSubmitCheck, usePreventScroll } from '../../../utils/hooks';
import { namePattern } from '../../signup/components/UserForm';
import info from '../assets/images/icons/info-blue.svg';
import GuestCheckoutInfoModal from './GuestCheckoutInfoModal';

export const FooterContentsOption = {
  Verification: 'email-verification',
  SignIn: 'sign-in',
  CreateAccount: 'create-account',
  BookNow: 'book-now',
  BookNowGuest: 'book-now-guest',
  MembershipRequiredGuest: 'membership-guest',
  ClaimProfile: 'claim-fishery',
};

export default function FisheryProfileFooterBar({
  footerContents,
  setFooterContents,
  onDrawerClose,
  fisheryPublicId,
  isComingSoon,
  isPackageBooking,
  isFromEvent = false,
  location = {},
}) {
  const containerRef = useRef();
  const [showSignInDrawer, setShowSignInDrawer] = useState(false);
  const [guestCheckoutVisible, setGuestCheckoutInfoVisible] = useState(false);

  const { data: fisheryData } = useGetFisheryQuery(fisheryPublicId, {
    skip: isFromEvent,
  });

  const { data: weatherData, isLoading: isWeatherLoading } = useWeather({
    location: isFromEvent ? location : fisheryData?.address?.location,
  });

  // Move chatbot widget above floating bar
  useEffect(() => {
    const chatBotWidget = document?.getElementById('brevo-conversations');
    if (!chatBotWidget) {
      return;
    }
    const originalPos = chatBotWidget.style.bottom;
    chatBotWidget.style.bottom = '130px';
    return () => {
      if (chatBotWidget) {
        chatBotWidget.style.bottom = originalPos;
      }
    };
  }, []);

  const footerButtonStyle =
    ' fishery_profile__footer__button gSemiBold brFull fs-20 white txt-center h-full pd-10 pd-left-28 pd-right-28 antd-link-button-override ';

  const signInFooter = (
    <>
      <div className={'fishery_profile__floating_footer_text'}>
        <b className={'gSemiBold fs-16'}>
          {isComingSoon
            ? 'Booking will soon be Live!'
            : 'Want to book this fishery?'}
        </b>
        <p className={'gRegular fs-16 mg-bottom-0'}>
          Sign in or{' '}
          <button
            className={'txt-underline sb-blue cp btn-clear '}
            onClick={() =>
              setFooterContents(FooterContentsOption.CreateAccount)
            }
          >
            create an account
          </button>
        </p>
      </div>

      {isComingSoon ? (
        <div className={'sb-active-grey-bg' + footerButtonStyle + 'black'}>
          Coming Soon
        </div>
      ) : (
        <Button
          className={'alt-light-blue-bg ' + footerButtonStyle}
          onClick={() => setShowSignInDrawer(true)}
        >
          Sign In
        </Button>
      )}
    </>
  );

  const membershipSignInFooter = (
    <>
      <div className={'fishery_profile__floating_footer_text'}>
        <b className={'gSemiBold fs-16'}>
          You require membership to book{' '}
          <span className='fishery_profile__hide-on-mobile'>this venue</span>
        </b>
        <p className={'gRegular fs-16 mg-bottom-0'}>
          Please{' '}
          <button
            className={'txt-underline sb-blue cp btn-clear '}
            onClick={() => setShowSignInDrawer(true)}
          >
            sign in
          </button>{' '}
          to your{' '}
          <span className='fishery_profile__hide-on-mobile'>swimbooker</span>{' '}
          account
        </p>
      </div>

      <Button
        className={'alt-light-blue-bg mg-left-5 ' + footerButtonStyle}
        style={{ margin: 'auto 0' }}
        onClick={() => setShowSignInDrawer(true)}
      >
        Sign In
      </Button>
    </>
  );

  const claimDirectoryFooter = (
    <>
      <div className={'fishery_profile__floating_footer_text'}>
        <b className={'gSemiBold fs-16'}>Own this fishery?</b>
        <p className={'gRegular fs-16 mg-bottom-0'}>Get in touch with us!</p>
      </div>
      <Button
        className={'bg-grey ' + footerButtonStyle}
        href={'/contact/fishery'}
      >
        Claim Fishery
      </Button>
    </>
  );

  const bookNowFooter = (
    <>
      <div className={'fishery_profile__floating_footer_text'}>
        <b className={'gSemiBold fs-16'}>Current Weather:</b>
        {isWeatherLoading ? (
          <Spin />
        ) : weatherData?.current ? (
          <Space
            direction={'horizontal'}
            align={'center'}
            className={'mg-bottom-0 cap sb-blue'}
          >
            <span className={'gSemiBold fs-22'}>
              {weatherData.current.temperature.current}&deg;C
            </span>
            <svg
              version='1.1'
              xmlns='http://www.w3.org/2000/svg'
              width={'2.25rem'}
              height={'2.25rem'}
              viewBox='0 -5 35 40'
              fill={'currentColor'}
            >
              <path d={weatherData.current.icon} />
            </svg>
          </Space>
        ) : (
          <span className={'gSemiBold red'}>Error</span>
        )}
      </div>

      {isComingSoon ? (
        <div className={'sb-active-grey-bg' + footerButtonStyle + 'black'}>
          Coming Soon
        </div>
      ) : (
        <a
          href={
            isPackageBooking
              ? `/booking/packages/${fisheryPublicId}`
              : // `/booking/new/${fisheryPublicId}`
                `/booking/new/${fisheryPublicId}`
          }
          style={{ margin: 'auto 0' }}
        >
          <Button className={'light-green-bg ' + footerButtonStyle}>
            Book Now
          </Button>
        </a>
      )}
    </>
  );

  const bookNowGuestFooter = (
    <>
      <GuestCheckoutInfoModal
        open={guestCheckoutVisible}
        onClose={() => setGuestCheckoutInfoVisible(false)}
      />
      <div className={'fishery_profile__floating_footer_text'}>
        <b className='gSemiBold fs-16 mg-bottom-5'>
          Want to book this fishery?
        </b>
        <p className='gRegular fs-16 lh-1.3 mg-bottom-0'>
          You can now <b className='gSemiBold'>checkout as a guest</b> on{' '}
          <b className='gSemiBold'>
            <span className='sb-blue-500'>swim</span>booker
          </b>{' '}
          <img
            src={info}
            role='button'
            alt='info'
            className='mg-left-5 cp'
            style={{
              height: '1em',
              width: '1em',
              verticalAlign: 'baseline',
              marginBottom: '-0.2em', // Offsets line-height change on parent
            }}
            onClick={() => setGuestCheckoutInfoVisible(true)}
          />
        </p>
      </div>

      {isComingSoon ? (
        <div className={'sb-active-grey-bg' + footerButtonStyle + 'black'}>
          Coming Soon
        </div>
      ) : (
        <a
          href={
            isPackageBooking
              ? `/booking/packages/${fisheryPublicId}`
              : // `/booking/new/${fisheryPublicId}`
                `/booking/new/${fisheryPublicId}`
          }
          style={{ margin: 'auto 0' }}
        >
          <Button className={'light-green-bg ' + footerButtonStyle}>
            Book Now
          </Button>
        </a>
      )}
    </>
  );

  const [createAccountFormRef] = Form.useForm();
  const [handleCreateAccountFormChange, disableCreateAccountSubmit] =
    useFormSubmitCheck(
      createAccountFormRef,
      [
        'first_name',
        'last_name',
        'email',
        'password',
        'confirm_password',
        'terms_and_conditions',
      ],
      true
    );

  const createAccountButton = (
    <Button
      className={
        (disableCreateAccountSubmit ? 'disabled ' : 'light-green-bg ') +
        footerButtonStyle +
        ' w-full'
      }
      onClick={() => createAccountFormRef && createAccountFormRef.submit()}
    >
      Create my account!
    </Button>
  );

  const closeDrawerButton = (
    <Button
      className={'bg-light-grey-2 ' + footerButtonStyle + ' w-full'}
      onClick={onDrawerClose}
    >
      Close Window
    </Button>
  );

  const verifyEmailMessage = (
    <SubSection title={'Verify Email'} noDivider justifyTitleDiv={'center'}>
      <Space
        direction={'vertical'}
        align={'center'}
        className={'w-full txt-center'}
      >
        <EmailIllustration className={'verify_email__image'} />
        <b className={'sb-blue gSemiBold txt-center fs-18'}>
          Welcome to swimbooker!
        </b>
        <p className={'gMedium sb-grey txt-center fs-16 mg-bottom-0'}>
          We’ve sent you an email with instructions on how to verify your
          account. Once complete, you will be able to sign in and book at any
          fishery on the platform.
        </p>
      </Space>
    </SubSection>
  );

  const handleCreateAccountFormSubmit = (values) => {
    let payload_data = {
      email: values.email,
      password: values.password,
      first_name: values.first_name,
      last_name: values.last_name,
      is_news_subscribed: Boolean(values?.is_news_subscribed),
    };

    axios
      .post('signup', payload_data)
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: <div className='gSemiBold'>Success!</div>,
            style: { border: '1px #2CB972 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Success',
          });
          setFooterContents(FooterContentsOption.Verification);
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing request',
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 500) {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Server Response failed. Please try again later',
          });
        } else if (err.response.status === 401) {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description:
              'Your action will not be saved. Please Login and try again!',
          });
        } else if (err.response.status === 400) {
          notification.warning({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: err.response.data['detail'],
          });
        } else if (err.response.status === 422) {
          if (err.response.data['detail'] === 'Signature has expired') {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                'Login session has been expired. Please Login to continue!',
            });
          } else {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                "OOPS! Server didn't like the request. If this persists please contact support team",
            });
          }
        }
      });
  };

  const createAccountForm = (
    <SubSection
      title={'Create an account'}
      noDivider
      justifyTitleDiv={'center'}
    >
      <Form
        layout={'vertical'}
        className={'fp_create_account_form'}
        colon={false}
        requiredMark={false}
        scrollToFirstError={{ block: 'start', boundary: containerRef?.current }}
        form={createAccountFormRef}
        onFieldsChange={handleCreateAccountFormChange}
        onFinish={handleCreateAccountFormSubmit}
      >
        <Form.Item
          label='First Name'
          name='first_name'
          rules={[
            {
              required: true,
              message: 'Please input your first name',
            },
            {
              pattern: namePattern,
              message: 'Unsupported character in first name',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Last Name'
          name='last_name'
          rules={[
            {
              required: true,
              message: 'Please input your last name',
            },
            {
              pattern: namePattern,
              message: 'Unsupported character in last name',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Email Address'
          name='email'
          rules={[
            { type: 'email', message: 'Please enter a valid email' },
            {
              required: true,
              message: 'Please input your email',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Create Password'
          name='password'
          rules={[
            {
              required: true,
              message: 'Please input a password',
            },
          ]}
        >
          <Input.Password
            autoComplete={'new-password'}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>
        <Form.Item
          name='confirm_password'
          label='Confirm Password'
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Please confirm your password',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('The two passwords that you entered do not match')
                );
              },
            }),
          ]}
        >
          <Input.Password
            autoComplete={'new-password'}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>
        <Form.Item
          name='terms_and_conditions'
          valuePropName='checked'
          rules={[
            {
              validator: async (_, checked) => {
                if (!checked) {
                  return Promise.reject(
                    new Error(
                      'You must accept the terms and conditions to continue'
                    )
                  );
                }
              },
            },
          ]}
        >
          <Checkbox>
            By creating an account, I verify that I agree with swimbooker’s data
            policy and terms and conditions.
          </Checkbox>
        </Form.Item>
        <Form.Item name='is_news_subscribed' valuePropName='checked'>
          <Checkbox>
            Keep me up to date with swimbooker’s new fisheries, updates, news
            and content.
          </Checkbox>
        </Form.Item>
      </Form>
    </SubSection>
  );

  let footerContentsComponent, drawerContentsComponent;
  switch (footerContents) {
    case FooterContentsOption.Verification:
      drawerContentsComponent = verifyEmailMessage;
      footerContentsComponent = closeDrawerButton;
      break;
    case FooterContentsOption.CreateAccount:
      drawerContentsComponent = createAccountForm;
      footerContentsComponent = createAccountButton;
      break;
    case FooterContentsOption.SignIn:
      drawerContentsComponent = null;
      footerContentsComponent = signInFooter;
      break;
    case FooterContentsOption.MembershipRequiredGuest:
      drawerContentsComponent = null;
      footerContentsComponent = membershipSignInFooter;
      break;
    case FooterContentsOption.BookNowGuest:
      drawerContentsComponent = null;
      footerContentsComponent = bookNowGuestFooter;
      break;
    case FooterContentsOption.BookNow:
      drawerContentsComponent = null;
      footerContentsComponent = bookNowFooter;
      break;
    case FooterContentsOption.ClaimProfile:
      drawerContentsComponent = null;
      footerContentsComponent = claimDirectoryFooter;
      break;
    default:
      drawerContentsComponent = null;
      footerContentsComponent = null;
  }

  const isVerticalDrawerOpen = Boolean(drawerContentsComponent);

  // Prevent background app scroll when drawer is open
  usePreventScroll('FisheryProfileFooter', isVerticalDrawerOpen);

  return (
    <div
      className={'fishery_profile__floating_footer__container'}
      ref={containerRef}
    >
      <div
        className={
          'fishery_profile__floating_footer__wrapper main_container_padding'
        }
      >
        <div
          className={
            'fishery_profile__floating_footer main_container_padding__content'
          }
        >
          {footerContentsComponent}
        </div>
      </div>

      <div className={'fishery_profile__floating_footer__drawer_container'}>
        <Drawer
          height={'fit-content'}
          className={'fishery_profile__floating_footer__drawer'}
          placement={'bottom'}
          open={isVerticalDrawerOpen}
          onClose={onDrawerClose}
          getContainer={false}
        >
          {drawerContentsComponent}
        </Drawer>
      </div>
      <MenuDrawer
        isOpen={showSignInDrawer}
        setIsOpen={setShowSignInDrawer}
        showFooter
      >
        <UserLoginForm useMobileButtonStyle />
      </MenuDrawer>
    </div>
  );
}
